import angular from 'angular';
import applicantAddRelatedParty from './applicantAddRelatedParty';

export default angular
  .module('components.applicantAddRelatedParty', [])
  .component('applicantAddRelatedParty', applicantAddRelatedParty).name;
